module.exports = __webpack_public_path__ + "img/invalid-feedback.c0a3ce25.svg";